module.exports = __webpack_public_path__ + "img/trash_icon.d0fc3b6a.png";